import { Card, Skeleton } from '@zond/ui';
import React from 'react';

export function AttendanceChartSkeleton() {
  return (
    <Card className="p-6">
      {/* Title and period selector */}
      <div className="flex justify-between items-center mb-6">
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-9 w-32" />
      </div>

      {/* Single large block for all remaining content */}
      <Skeleton className="h-[250px] w-full rounded-md" />
    </Card>
  );
}
